import React, { useState, useEffect } from 'react';

import { FormRadio } from './FormRadio';

import { func_validation } from 'functions';

import "assets/scss/components/form/formGroupRadio.scss";



export function FormGroupRadio(props) {
    // Props
    const {
        label,
        className, labelClassName,
        radioClassName, radioButtonsClassName, radioLabelClassName,
        radioList, defaultSelectedRadio, isInputRequired,
        isFormSubmissionAttempted, customErrorValidation, errorMsg,
        isDisabled
    } = props;

    // Props validations
    let label_validated = func_validation.isStringTrimNotEmpty(label)? label: "";
    let radioList_validated = func_validation.isArrayNotEmpty(radioList)? radioList: [];
    let errorMsg_validated = func_validation.isStringTrimNotEmpty(errorMsg)? errorMsg: "";

    // States
    const [radioGroupName] = useState(func_validation.getStringUniqueId("component-formGroupRadio"));
    const [selectedRadio, setSelectedRadio] = useState(defaultSelectedRadio);

    // Updating states from parent
    function updateDefaultValue() {
        if (func_validation.isNotNullUndefined(defaultSelectedRadio))
            setSelectedRadio(defaultSelectedRadio);

    }
    useEffect(() => {
        updateDefaultValue();
    }, [defaultSelectedRadio]);

    // Update States
    function handleRadioChange(value) {
        setSelectedRadio(value);

        if (props.handleRadioChange &&
            func_validation.isNotNullUndefined(value))
            props.handleRadioChange(value);
    }

    // Error
    let isErrorPresent = isFormSubmissionAttempted && func_validation.isNullUndefined(selectedRadio) &&
        (errorMsg_validated != "");
    if (customErrorValidation) isErrorPresent = customErrorValidation;

    // Generate radio buttons
    let radioButtons = radioList_validated.map((radioItem, idx) => {
        let value = radioItem?.value;
        let label = radioItem?.label;

        return (
            <FormRadio key={idx}
                className={radioClassName}
                radioGroupName={radioGroupName} 
                radioValue={value}
                isRadioDisabled={isDisabled}
                
                labelClassName={radioLabelClassName}
                radioLabel={label}

                isSelected={selectedRadio === value}

                handleRadioSelection={handleRadioChange}

                isError={isErrorPresent}
            />
        )
    });

    return (
        <div className={"component-formGroupRadio " + 
                (className? className + " ":"")}>
            {/* Group Label */}
            <div className={"component-formGroupRadio-labelWrapper " +
                    (labelClassName? labelClassName + " ":"")}>
                <span className={"component-formGroupRadio-label"}>
                    {label_validated}
                </span>
                {isInputRequired? (
                    <span className={"component-formGroupRadio-label-requiredSymbol"}>*</span>
                ):""}
            </div>

            {/* Radio Buttons */}
            <div className={"component-formGroupRadio-radioButtons " +
                        (radioButtonsClassName? radioButtonsClassName + " ":"")}>
                {radioButtons}
            </div>

            {/* Error Message */}
            {isErrorPresent? (
                <div className={"component-formGroupRadio-errorMsg "}>
                    {errorMsg_validated}
                </div>
            ):""}
        </div>
    );
}